var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "#00247D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5L9.4 6H12L2.6 1.5H0Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.5L14.6 6H12L21.4 1.5H24Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5L14.6 10H12L21.4 14.5H24Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5L9.4 10H12L2.6 14.5H0Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8L8.8 8.5H11L0 13.8V12.8Z",
    fill: "#CF142B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.8L15.2 8.5H13L24 13.8V12.8Z",
    fill: "#CF142B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.2L15.2 7.5H13L24 2.2V3.2Z",
    fill: "#CF142B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2L8.8 7.5H11L0 2.2V3.2Z",
    fill: "#CF142B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0h4v16h-4z",
    fill: "#FFFFFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6h24v4H0z",
    fill: "#FFFFFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0h2v16h-2z",
    fill: "#CF142B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7h24v2H0z",
    fill: "#CF142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag_en.234e578122ba7f0b8f818be3c9d9f606.svg";
export { ForwardRef as ReactComponent };